import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;
export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    ...sharedConfig['nl-NL'].seo,
    title: 'Algemene Voorwaarden | Lemonade Inboedel- en Aansprakelijkheidsverzekering Nederland',
    metaTitle: 'Algemene Voorwaarden | Lemonade Inboedel- en Aansprakelijkheidsverzekering Nederland',
    description:
      'Lees de algemene voorwaarden van Lemonade Nederland om meer te weten over je rechten, plichten en het gebruik van onze verzekeringsdiensten.',
  },
  MDXContent: content as DocumentTypes,
};
